// Google Maps API Configuration
export const GOOGLE_MAPS_CONFIG = {
  // API Key - should be set in environment variables
  apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || 'AIzaSyA4rfDmd2xe_od5l_APL7raqcTqXSfl9Y0',
  
  // Libraries to load
  libraries: ['places'],
  
  // Default options for autocomplete
  autocompleteOptions: {
    types: ['address'],
    componentRestrictions: { country: 'us' }, // Restrict to US addresses
    fields: [
      'address_components', 
      'formatted_address', 
      'geometry', 
      'place_id',
      'name',
      'types'
    ]
  },
  
  // Default map options
  mapOptions: {
    center: {
      lat: 39.8283, // Center of US
      lng: -98.5795
    },
    zoom: 4
  }
};

// Helper function to check if API key is configured
export const isGoogleMapsConfigured = () => {
  return !!GOOGLE_MAPS_CONFIG.apiKey;
};

// Helper function to get API key with fallback message
export const getGoogleMapsApiKey = () => {
  if (!GOOGLE_MAPS_CONFIG.apiKey) {
    console.warn('Google Maps API key not configured. Please set REACT_APP_GOOGLE_MAPS_API_KEY in your environment variables.');
  }
  return GOOGLE_MAPS_CONFIG.apiKey;
};
